<div class="post-content">
  <div
    class="
      fusion-fullwidth
      fullwidth-box
      fusion-builder-row-1 fusion-parallax-none
      nonhundred-percent-fullwidth
      non-hundred-percent-height-scrolling
    "
    style="
      background-color: rgba(255, 255, 255, 0);
      background-image: url('/wp-content/uploads/2015/12/about-call-to-action-57862405-1024x630.jpg');
      background-position: center center;
      background-repeat: no-repeat;
      padding-top: 150px;
      padding-right: 30px;
      padding-bottom: 0px;
      padding-left: 30px;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
    "
  >
    <div class="fusion-builder-row fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_1
          fusion-builder-column-0
          fusion-one-full
          fusion-column-first
          fusion-column-last
          1_1
        "
        style="margin-top: 0px; margin-bottom: 0px"
      >
        <div
          class="fusion-column-wrapper"
          style="
            padding: 0px;
            background-position: left top;
            background-repeat: no-repeat;
            background-size: cover;
            height: auto;
          "
          data-bg-url=""
        >
          <style type="text/css">
            @media only screen and (max-width: 800px) {
              .fusion-title.fusion-title-1 {
                margin-top: 10px !important;
                margin-bottom: 10px !important;
              }
            }
          </style>
          <div
            class="
              fusion-title
              title
              fusion-title-1
              fusion-sep-none
              fusion-title-text
              fusion-title-size-one
              fusion-border-below-title
            "
            style="margin-top: 0px; margin-bottom: 10px"
          >
            <h1
              class="title-heading-left fusion-responsive-typography-calculated"
              style="margin: 0px; --fontSize: 50; line-height: 1.4"
              data-fontsize="50"
              data-lineheight="70px"
            ></h1>
            <h1
              style="text-align: center; --fontSize: 50; line-height: 1.4"
              data-fontsize="50"
              data-lineheight="70px"
              class="fusion-responsive-typography-calculated"
            >
              <span style="color: #ffffff">LASCIA UN FEEDBACK</span>
            </h1>
          </div>
          <div class="fusion-sep-clear"></div>
          <div
            class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 100px"
          ></div>
          <div
            class="
              fusion-section-separator
              section-separator
              big-half-circle
              fusion-section-separator-with-offset
            "
            style="
              padding: 0;
              margin-left: calc((100vw - 100%) / -2);
              margin-right: calc((100vw - 100%) / -2);
            "
          >
            <svg
              class="fusion-big-half-circle-candy"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              width="100%"
              height="100"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              style="fill: #ffffff; padding: 0"
            >
              <path d="M0 100 C40 0 60 0 100 100 Z"></path>
            </svg>
          </div>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="
      fusion-fullwidth
      fullwidth-box
      fusion-builder-row-2
      nonhundred-percent-fullwidth
      non-hundred-percent-height-scrolling
    "
    style="
      background-color: rgba(255, 255, 255, 0);
      background-position: center center;
      background-repeat: no-repeat;
      padding-top: 0px;
      padding-right: 30px;
      padding-bottom: 0px;
      padding-left: 30px;
    "
  >
    <div class="fusion-builder-row fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_1
          fusion-builder-column-1
          fusion-one-full
          fusion-column-first
          fusion-column-last
          1_1
        "
        style="margin-top: 0px; margin-bottom: 0px"
      >
        <div
          class="fusion-column-wrapper"
          style="
            padding: 0px;
            background-position: left top;
            background-repeat: no-repeat;
            background-size: cover;
            height: auto;
          "
          data-bg-url=""
        >
          <div class="fusion-text">
            <h2
              style="text-align: center; --fontSize: 32; line-height: 1.31"
              data-fontsize="32"
              data-lineheight="41.92px"
              class="fusion-responsive-typography-calculated"
            >
              RACCONTACI DELLA TUA ESPERIENZA
            </h2>
          </div>
          <div class="fusion-sep-clear"></div>
          <div
            class="fusion-separator sep-single sep-solid"
            style="
              border-color: #ffa626;
              border-top-width: 2px;
              margin-left: auto;
              margin-right: auto;
              margin-top: 0px;
              margin-bottom: 30px;
              width: 100%;
              max-width: 206px;
            "
          ></div>
          <div class="fusion-text">
            <p style="text-align: center">
              Ti invitiamo a raccontarci della tua esperienza compilando questo breve
              sondaggio.
            </p>
          </div>
          <div class="fusion-sep-clear"></div>
          <div
            class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 40px"
          ></div>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <style type="text/css">
    .fusion-fullwidth.fusion-builder-row-2
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
    .fusion-fullwidth.fusion-builder-row-2
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
    .fusion-fullwidth.fusion-builder-row-2
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
      color: #ffa626;
    }
    .fusion-fullwidth.fusion-builder-row-2
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
    .fusion-fullwidth.fusion-builder-row-2
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
    .fusion-fullwidth.fusion-builder-row-2
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
      color: #ffa626;
    }
    .fusion-fullwidth.fusion-builder-row-2 .pagination a.inactive:hover,
    .fusion-fullwidth.fusion-builder-row-2
      .fusion-filters
      .fusion-filter.fusion-active
      a {
      border-color: #ffa626;
    }
    .fusion-fullwidth.fusion-builder-row-2 .pagination .current {
      border-color: #ffa626;
      background-color: #ffa626;
    }
    .fusion-fullwidth.fusion-builder-row-2
      .fusion-filters
      .fusion-filter.fusion-active
      a,
    .fusion-fullwidth.fusion-builder-row-2
      .fusion-date-and-formats
      .fusion-format-box,
    .fusion-fullwidth.fusion-builder-row-2 .fusion-popover,
    .fusion-fullwidth.fusion-builder-row-2 .tooltip-shortcode {
      color: #ffa626;
    }
    #main
      .fusion-fullwidth.fusion-builder-row-2
      .post
      .blog-shortcode-post-title
      a:hover {
      color: #ffa626;
    }
  </style>
  <div
    class="
      fusion-fullwidth
      fullwidth-box
      fusion-builder-row-3
      nonhundred-percent-fullwidth
      non-hundred-percent-height-scrolling
      fusion-equal-height-columns
    "
    style="
      background-color: #ffffff;
      background-position: left top;
      background-repeat: no-repeat;
      padding-top: 0px;
      padding-right: 0px;
      padding-bottom: 50px;
      padding-left: 0px;
      border-top-width: 0px;
      border-bottom-width: 0px;
      border-color: #eae9e9;
      border-top-style: solid;
      border-bottom-style: solid;
    "
  >
    <div class="fusion-builder-row fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_1
          fusion-builder-column-2
          fusion-one-full
          fusion-column-first
          fusion-column-last
          fusion-column-no-min-height
          1_1
        "
        style="margin-top: 0px; margin-bottom: 0px"
      >
        <div
          class="fusion-column-wrapper"
          style="
            background-color: rgb(239, 239, 239);
            padding: 30px 30px 50px;
            background-position: left top;
            background-repeat: no-repeat;
            background-size: cover;
            min-height: 633px;
            height: auto;
          "
          data-bg-url=""
        >
          <div
            class="fusion-column-content-centered"
            style="min-height: 633px; height: auto"
          >
            <div class="fusion-column-content">
              <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()">
                <app-feedback-rigore [desc]="ratingList[0]" [form]="feedbackForm.get('RATING_RIGORE')">
                </app-feedback-rigore>
                <app-feedback-qualita [desc]="ratingList[1]"[form]="feedbackForm.get('RATING_QUALITA')">
                </app-feedback-qualita>
                <app-feedback-professionalita [desc]="ratingList[2]"[form]="feedbackForm.get('RATING_PROFESSIONALITA')">
                </app-feedback-professionalita>
                <app-feedback-sicurezza [desc]="ratingList[3]"[form]="feedbackForm.get('RATING_SICUREZZA')"></app-feedback-sicurezza>
                <app-feedback-ordine [desc]="ratingList[4]"[form]="feedbackForm.get('RATING_ORDINE_PULIZIA')"></app-feedback-ordine>




                <!-- <app-feedback-section
                  [form]="feedbackForm"
                  [type]="'RATING_RIGORE'"
                >
                </app-feedback-section>



                <app-feedback-section
                  [form]="feedbackForm"
                  [type]="'RATING_QUALITA'"
                >
                </app-feedback-section>
                <app-feedback-section
                  [form]="feedbackForm"
                  [type]="'RATING_PROFESSIONALITA'"
                >
                </app-feedback-section>
                <app-feedback-section
                  [form]="feedbackForm"
                  [type]="'RATING_SICUREZZA'"
                >
                </app-feedback-section>
                <app-feedback-section
                  [form]="feedbackForm"
                  [type]="'RATING_ORDINE_PULIZIA'"
                >
                </app-feedback-section> -->

                <!-- <li class="fusion-li-item" formGroupName="RATING_RIGORE">
                  <input
                    id="MRCEA"
                    type="checkbox"
                    class="yellowBorderedCheckbox"
                    formControlName="MRCEA"
                  />
                  <label
                    for="MRCEA"
                    class="fusion-text"
                    style="font-size: 20px; color: #666666"
                    ><span></span>MRCEA</label
                  >
                  <input
                    id="MRTEA"
                    type="checkbox"
                    class="yellowBorderedCheckbox"
                    formControlName="MRTEA"
                  />
                  <label
                    for="MRTEA"
                    class="fusion-text"
                    style="font-size: 20px; color: #666666"
                    ><span></span>MRTEA</label
                  >
                </li> -->

                <div class="fusion-text">
                  <h3
                    style="
                      text-align: center;
                      --fontSize: 28;
                      line-height: 1.45;
                    "
                    data-fontsize="28"
                    data-lineheight="40.6px"
                    class="fusion-responsive-typography-calculated"
                  >
                    NOTE AGGIUNTIVE
                  </h3>
                  <div class="fusion-aligncenter">
                    <textarea formControlName="feedbackComment"
                      class="css-input"
                      name="notes"
                      id="notes"
                      cols="30"
                      rows="10"
                      style="width: 90%"
                    ></textarea>
                  </div>
                </div>
                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 50px;
                  "
                ></div>
                <button
                  class="fusion-button-wrapper fusion-aligncenter"
                  type="submit"
                  style="border: 0;"
                >
                  <style type="text/css">
                    .fusion-button.button-2 {
                      border-radius: 0px;
                    }
                  </style>
                  <a
                    class="
                      fusion-button
                      button-flat
                      fusion-button-default-size
                      button-default button-2
                      fusion-button-default-span fusion-button-default-type
                    "
                    target="_self"
                    ><span class="fusion-button-text">INVIA FEEDBACK</span></a
                  >
                </button>
              </form>
            </div>
          </div>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <style type="text/css">
    .fusion-fullwidth.fusion-builder-row-3
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
    .fusion-fullwidth.fusion-builder-row-3
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
    .fusion-fullwidth.fusion-builder-row-3
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
      color: #ffa626;
    }
    .fusion-fullwidth.fusion-builder-row-3
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
    .fusion-fullwidth.fusion-builder-row-3
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
    .fusion-fullwidth.fusion-builder-row-3
      a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
      color: #ffa626;
    }
    .fusion-fullwidth.fusion-builder-row-3 .pagination a.inactive:hover,
    .fusion-fullwidth.fusion-builder-row-3
      .fusion-filters
      .fusion-filter.fusion-active
      a {
      border-color: #ffa626;
    }
    .fusion-fullwidth.fusion-builder-row-3 .pagination .current {
      border-color: #ffa626;
      background-color: #ffa626;
    }
    .fusion-fullwidth.fusion-builder-row-3
      .fusion-filters
      .fusion-filter.fusion-active
      a,
    .fusion-fullwidth.fusion-builder-row-3
      .fusion-date-and-formats
      .fusion-format-box,
    .fusion-fullwidth.fusion-builder-row-3 .fusion-popover,
    .fusion-fullwidth.fusion-builder-row-3 .tooltip-shortcode {
      color: #ffa626;
    }
    #main
      .fusion-fullwidth.fusion-builder-row-3
      .post
      .blog-shortcode-post-title
      a:hover {
      color: #ffa626;
    }
  </style>
</div>
